module.exports = __webpack_public_path__ + "img/excel.775cf0e0.png";